// extracted by mini-css-extract-plugin
export default {"container":"SubscribersEmptyMessage_container__tEOO1","textContainer":"SubscribersEmptyMessage_textContainer__6Csih"};